<div class="products-route lifeislife-header-route">

  <a [routerLink]="['/mandate']"
     class="sticky-button lifeislife-button-link mandate-request-action-button"
  >
    <span i18n>Transférer d'autres contrats vers LifeisLife</span>
  </a>

  <header>
    <h1>Mes produits</h1>


    <div class="header-subtitle">
    </div>

  </header>


  <div class="products-family">

    <cf-family-product-list [family]="InsuranceCategoryFamily.RETIREMENT"
                            [showEntryDetails]="showDetails"
                            [showEntryReserve]="true"
    >
      <ng-template cfFamilyProductSubtitle>
        <a [routerLink]="['/products', 'pensionstatus']"
           class="header-subtitle"
        >
          <span i18n>Où en suis-je dans mon épargne ?</span>
        </a>
      </ng-template>
      <ng-template cfFamilyProductSubheader>

        <div *ngIf="(pensionProductsModel$ | async) == null; else pensionModelLoaded">
          <p>Chargement des informations relatives aux produits pension...</p>
        </div>
        <ng-template #pensionModelLoaded>
          <p-tabView *ngIf="pensionProductPerContactFeature$ | async; else singleGroup">
            <p-tabPanel *ngFor="let model of pensionProductsModel$ | async"
                        [header]="model.insuredContactName">
              <cf-contact-pension-preview [contactPreviewModel]="model"
                                          [showContactHeader]="false"
                                          [showChartsLegalStrings]="false"
                                          [showChartsLegend]="false"
                                          [showProgressionBar]="false"
              ></cf-contact-pension-preview>
            </p-tabPanel>
          </p-tabView>
          <ng-template #singleGroup>
            <cf-contact-pension-preview [contactPreviewModel]="(pensionProductsModel$ | async)[0]"
                                        *ngIf="(pensionProductsModel$ | async)?.length === 1"
                                        [showContactHeader]="false"
                                        [showChartsLegalStrings]="false"
                                        [showChartsLegend]="false"
                                        [showProgressionBar]="false"
            ></cf-contact-pension-preview>
          </ng-template>

        </ng-template>

      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.MOBILITY"
                            [showEntryDetails]="showDetails"
    >
      <ng-template cfFamilyProductSubtitle>
      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.HOME"
                            [showEntryDetails]="showDetails"
    >
      <ng-template cfFamilyProductSubtitle>
      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.WORK"
                            [showEntryDetails]="showDetails"
    >
      <ng-template cfFamilyProductSubtitle>
      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.INVESTMENTS"
                            [showEntryDetails]="showDetails"
                            [showEntryReserve]="true"
    >
      <ng-template cfFamilyProductSubtitle>
      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.INCOME_GUARANTEE"
                            [showEntryDetails]="showDetails"
    >
      <ng-template cfFamilyProductSubtitle>

      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.HEALTH"
                            [showEntryDetails]="showDetails"
    >
      <ng-template cfFamilyProductSubtitle>
      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.FAMILY"
                            [showEntryDetails]="showDetails"
    >
      <ng-template cfFamilyProductSubtitle>
      </ng-template>
    </cf-family-product-list>

    <cf-family-product-list [family]="InsuranceCategoryFamily.DEATH"
                            [showEntryDetails]="showDetails"
                            [showEntryReserve]="true"
    >
      <ng-template cfFamilyProductSubtitle>

      </ng-template>
    </cf-family-product-list>

  </div>


  <div class="call-to-action">
    <a class="lifeislife-button-link"
       (click)="onNewSourcingRequestClick()"
    >
      Je voudrais plus d'informations sur les autres produits LifeisLife
    </a>
  </div>

  <cf-insurance-request-draft-dialog [ticket]="editingInsuranceInfoReaquestDraf$ | async"
  ></cf-insurance-request-draft-dialog>


  <div class="partners">
    <div class="partners-bloc">
      <h1> Nos partenaires </h1>
      <llc-insurance-partner-icons></llc-insurance-partner-icons>
    </div>
  </div>

</div>
